export default __webpack_public_path__ + "44d96f6b9b858526aea64f438f75c7ab.jpg";